/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Cashflow_Caveat_CancelledInputs */

const vi_cashflow_caveat_cancelled = /** @type {(inputs: Cashflow_Caveat_CancelledInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tiền vào đã loại các khoản trên đơn đã huỷ/hoàn.`)
};

/**

* @param {Cashflow_Caveat_CancelledInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const cashflow_caveat_cancelled = /** @type {((inputs?: Cashflow_Caveat_CancelledInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Cashflow_Caveat_CancelledInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_cashflow_caveat_cancelled(inputs)
});